import * as React from 'react';
import Radio from '@mui/material/Radio';
import { Box, FormControlLabel } from '@mui/material';

export default function BaseRadio({
  sx,
  sxLabel,
  label,
  checked,
  value,
  name,
  onChange,
  required
}) {
  const controlProps = (item) => ({
    checked,
    onChange,
    value,
    name: name,
    inputProps: { 'aria-label': item },
  });

  return (
    <Box
      sx={{
        '.MuiFormControlLabel-root': {
          alignItems: 'flex-start'
        }
      }}
    >
      <FormControlLabel
        sx={{
          '& .MuiFormControlLabel-label': {
            fontSize: '15px',
            whiteSpace: 'nowrap',
            color: 'primary.darkBlack',
            ml: '4px',
            ...sxLabel
          }
        }}
        control={
          <Box
            sx={{
              '& .MuiRadio-root': {
                padding: 0
              }
            }}
          >
            <Radio
              {...controlProps('c')}
              sx={{
                color: 'primary.mediumGray',
                
                '&.Mui-checked': {
                    color: 'primary.mainBlue',
                },
                '& .MuiSvgIcon-root': {
                  fontSize: 28,
                  ...sx
                },
              }}
            />
          </Box>
        }
        label={label}
        required={required}
      />
    </Box>
  );
}